import { useState } from "react";

import type { EntryPreset } from "../../types";

export type { EntryPreset };

/** The "Add transaction" sheet: whether it is open, what it starts with, and whether it has saved. */
export function useEntryModal() {
  const [open, setOpen] = useState(false);
  const [preset, setPreset] = useState<EntryPreset | null>(null);
  const [saved, setSaved] = useState(false);
  return {
    open, preset, saved,
    show: (start: EntryPreset | null = null) => {
      setSaved(false);
      setPreset(start);
      setOpen(true);
    },
    close: () => {
      setOpen(false);
      setPreset(null);
    },
    markSaved: () => setSaved(true),
  };
}
